import React from "react";

const TitleDescription = ({ text, readMoreUrl }) => {
  return (
    <div className="text-center md:mb-8">
      <div className="md:text-2xl" dangerouslySetInnerHTML={{ __html: text }} />
      {readMoreUrl !== undefined && (
        <a className="text-orange-400" href={readMoreUrl}>
          {" "}
          Scopri di più
        </a>
      )}
    </div>
  );
};
export default TitleDescription;
